import "../../pages/templates/templates.css";
import "./message-thumb.css";
import {MessageTemplateProps} from "../../types/MessageTemplateProps";
import WhatsappDefaultBackground from "../../assets/images/whatsapp-default-wallpaper.png";
import {PictureFilled} from "@ant-design/icons";
import {millisecondsToHuman} from "../../utils/friendlyDate";
import millify from "millify";
import useAppContext from "../../hooks/useAppContext";
import {FlowProps} from "../../types/FlowProps";
import {TimerIcon} from "../../assets/icons/TimerIcon";

interface MessageThumbProps {
    item: MessageTemplateProps;
    flow?: FlowProps;
    onNotificationClick: () => void;
    index: number;
    isDraftView?: boolean;
}

const MessageThumb = ({ item, onNotificationClick, flow, index, isDraftView = false }: MessageThumbProps) => {
    const {title, content, withImage, triggerDelay, distributionPercent, active, totalSent, totalRecovered, totalMoneyRecoveredUsd, whatsappTemplateStatus} = item;
    const { data: { templates } } = useAppContext();
    const statusLowerCase = whatsappTemplateStatus?.toLowerCase() || '';
    const isApproved = statusLowerCase === "approved";
    const isPending = statusLowerCase === "pending";
    const isActive = active && isApproved;
    const isDisabled = !active;


    return (
        <div className={`message-thumb-container ${isDraftView ? 'draft' : ''}`} onClick={onNotificationClick} style={{ zIndex: flow?.templates ? flow.templates.length - index : templates.data.length - index }}>
            <div className="icons">
                <div className="row">
                    {withImage ? <div className="with-image"><PictureFilled /></div> : null}
                    {isActive ? <div className="status activated" /> : isPending ? <div className="status pending" /> : <div className="status deactivated" />}
                </div>
            </div>
            <div className={`message-thumb-status ${isDisabled ? 'DISABLED' : whatsappTemplateStatus}`}>
                {isDisabled ? 'disabled' : statusLowerCase}
            </div>
            <div className="message-thumb-preview-container" style={{ backgroundImage: `url(${WhatsappDefaultBackground})` }}>
                <div className="message-thumb-preview">
                    {content}
                </div>
            </div>
            <div className="message-thumb-details">
                <div className="message-thumb-headline">
                    <div className="message-thumb-title">
                        <span>{title}</span>
                        <div className="trigger-delay"><TimerIcon width={18} color='#303a6c' /><span>{triggerDelay === 0 ? 'Immediately on' : `${millisecondsToHuman(triggerDelay*1000)} delay from`}</span> trigger</div>
                    </div>
                </div>
                <div className="message-thumb-data-container">
                    <div className="left">
                        <div className="message-thumb-data revenue">
                            <span>${totalMoneyRecoveredUsd ? millify(totalMoneyRecoveredUsd) : 0}</span> Recovered
                        </div>
                    </div>
                    <div className="right">
                        <div className="message-thumb-data revenue">
                            <span>${totalSent && totalMoneyRecoveredUsd ? Math.round(totalMoneyRecoveredUsd/totalSent) : 0}</span> RPS
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MessageThumb;